import Barba from 'barba.js';
import $ from 'jquery'
import projecthover from '../../modules/project-hover.js'


var aboutView = function() {

  var About = Barba.BaseView.extend({
    namespace: 'about',
    onEnter: function() {
      projecthover();
    },
    onEnterCompleted: function() {
      $(window).scroll();
    },
    onLeave: function() {
    },
    onLeaveCompleted: function() {
    }
  });

  About.init();
}

module.exports = aboutView;



// WEBPACK FOOTER //
// ./resources/assets/js/barba/views/about-view.js